import './bloque.css'
import quehagowords from './quehagoDictionary';
import { useSelector } from 'react-redux';
import { languageSwitch } from '../../dictionary/translateFunctions';
import { cvDownload } from '../../conexiones/varConexiones';
import Banner from '../banners/Banners';

const Bloque = () => {
    const lang = useSelector((state) => state.lang.lang);
    const dictionary = quehagowords;
    return(
            <div className="section_quehago">
                {/* <div className='titulo_queHago'>
                    <h2>{languageSwitch(dictionary.qt1,lang)}</h2>
                </div> */}
                <Banner type={'1'} title={dictionary.qb1.qb1t1[lang]} text={dictionary.qb1.qb1d1[lang]} icons={['figma','sketch','maze','hotjar','miro','jira','scrum']} skills={dictionary.qbl[lang]}></Banner>
                <Banner type={'2'} title={dictionary.qb2.qb2t2[lang]} text={dictionary.qb2.qb2d2[lang]} icons={['photoshop','illustrator','indesign','after','premier']} skills={dictionary.qbl[lang]}></Banner>
                <Banner type={'2'} title={dictionary.qb3.qb3t3[lang]} text={dictionary.qb3.qb3d3[lang]} icons={['css','html','javascript','jira','react']} skills={dictionary.qbl[lang]}></Banner>            
            </div>
    )
}


export default Bloque;